export default __webpack_public_path__ + "static/media/usersIcon.f78d5c0d.svg";